@if (richLinkForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="richLinkForm">
          <div class="control-div">
            <input #imageRef [formControlName]="'image'" hidden>
            <select-media [image]="imageRef.value" [imageOnly]="true" (setImageRef)="setImage($event, richLinkForm)">
            </select-media>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Title </label>
            </div>
            <clickatell-form-validation [controlName]="'title'"
            [form]="richLinkForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="richLinkForm" id="title"
              [formControlName]="'title'" placeholder="Enter a title"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> URL </label>
              </div>
              <clickatell-form-validation [controlName]="'url'"
              [form]="richLinkForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="richLinkForm" id="url"
                [formControlName]="'url'" placeholder="Enter a url"/>
              </div>
              <div class="control-div">
                <div class="slider-block">
                  <mat-button-toggle-group #previewType="matButtonToggleGroup" [value]="richLinkForm?.controls['previewType']?.value" [multiple]="false"
                    [formControlName]="'previewType'"
                    (change)="previewTypeChanged(previewType)"
                    hideSingleSelectionIndicator>
                    <mat-button-toggle class="selector-button" [value]="'IMAGE'">URL</mat-button-toggle>
                    <mat-button-toggle class="selector-button" [value]="'VIDEO'">Video</mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
              </div>
              @if (previewType.value === 'VIDEO') {
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Video Url </label>
                  </div>
                  <clickatell-form-validation [controlName]="'videoUrl'"
                  [form]="richLinkForm"></clickatell-form-validation>
                  <input class="control-input" activeForm [activeForm]="richLinkForm" id="videoUrl"
                    [formControlName]="'videoUrl'" placeholder="Enter a video url"/>
                  </div>
                  <div class="control-div">
                    <div class="control-label-container">
                      <label class="control-label"> Mime Type </label>
                    </div>
                    <clickatell-form-validation [controlName]="'videoMimeType'"
                    [form]="richLinkForm"></clickatell-form-validation>
                    <input class="control-input" activeForm [activeForm]="richLinkForm" id="videoMimeType"
                      [formControlName]="'videoMimeType'" placeholder="Enter a mime type"/>
                    </div>
                  }
                </ng-container>
              </ng-container>
            </clickatell-expansion-panel>
            <clickatell-expansion-panel>
              <ng-container header>
                <mat-panel-title>
                  WhatsApp
                </mat-panel-title>
              </ng-container>
              <ng-container body>
                <ng-container [formGroup]="richLinkForm">
                  @if (isBodyEmpty()) {
                    <div class="banner-container">
                      <div class="banner-block">
                        <div class="icon"></div>
                        <div class="content">
                          Body is a required field for Whatsapp Call To Action buttons. If you do not intend to use Call To Action, you can leave this empty.
                        </div>
                      </div>
                    </div>
                  }
                  <div class="control-div">
                    <div class="control-label-container">
                      <label class="control-label"> Menu Header </label>
                    </div>
                    <clickatell-form-validation [controlName]="'menuHeader'"
                    [form]="richLinkForm"></clickatell-form-validation>
                    <input class="control-input" activeForm [activeForm]="richLinkForm" id="menuHeader"
                      [formControlName]="'menuHeader'" placeholder="Enter a menu header"/>
                    </div>
                    <div class="control-div">
                      <div class="control-label-container">
                        <label class="control-label"> Menu Media Header </label>
                      </div>
                      <clickatell-form-validation [controlName]="'menuMediaLink'"
                      [form]="richLinkForm"></clickatell-form-validation>
                      <input class="control-input" activeForm [activeForm]="richLinkForm" id="menuMediaLink"
                        [formControlName]="'menuMediaLink'" placeholder="Enter a media link (URL)"/>
                    </div>
                    <div class="control-div">
                      <div class="control-label-container">
                        <label class="control-label"> Menu Media Header Type </label>
                      </div>
                      <clickatell-form-validation [controlName]="'menuMediaType'"
                      [form]="richLinkForm"></clickatell-form-validation>
                      <mat-select activeForm [activeForm]="richLinkForm" id="menuMediaType"
                        [formControlName]="'menuMediaType'"
                        class="control-dropdown" hideSingleSelectionIndicator>
                        <mat-option value="">None</mat-option>
                        <mat-option value="document">Document</mat-option>
                        <mat-option value="image">Image</mat-option>
                        <mat-option value="video">Video</mat-option>
                      </mat-select>
                    </div>
                    <div class="control-div">
                      <div class="control-label-container">
                        <label class="control-label"> Body </label>
                      </div>
                      <clickatell-form-validation [controlName]="'body'"
                      [form]="richLinkForm"></clickatell-form-validation>
                      <textarea class="control-textArea" activeForm [activeForm]="richLinkForm" id="body"
                        [formControlName]="'body'" [attr.name]="'body'"
                      placeholder="Enter body text"></textarea>
                    </div>
                    <div class="control-div">
                      <div class="control-label-container">
                        <label class="control-label"> Footer </label>
                      </div>
                      <clickatell-form-validation [controlName]="'footer'"
                      [form]="richLinkForm"></clickatell-form-validation>
                      <input class="control-input" activeForm [activeForm]="richLinkForm" id="footer"
                        [formControlName]="'footer'" placeholder="Enter a footer"/>
                      </div>
                    </ng-container>
                  </ng-container>
                </clickatell-expansion-panel>
                <clickatell-expansion-panel>
                  <ng-container header>
                    <mat-panel-title>
                      Logic
                    </mat-panel-title>
                  </ng-container>
                  <ng-container body>
                    <ng-container [formGroup]="richLinkForm">
                      <div class="control-result">
                        <div class="control-result-header">
                          Next
                        </div>
                        <div class="control-result-container">
                          <div class="control-div">
                            <label class="control-label">
                              <span class="pont-to">Point To</span>
                              <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                            </label>
                            @if (nodeFlowDetails) {
                              <next-selector [canEditFlows]="canEdit.canEditFlows"
                                [selectorType]="'both'"
                                [flowSteps]="nodeFlowDetails.currentFlowSteps"
                                [flows]="nodeFlowDetails.flows"
                                [name]="'next'"
                                [form]="richLinkForm"
                                [stepId]="nodeFlowDetails.stepId">
                              </next-selector>
                            }
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </clickatell-expansion-panel>
              </div>
            }